import React from 'react';
import './styles/order-tracker-header-mobile.css';

interface OrderTrackerHeaderMobileProps {
  orderId: string;
  onBack?: () => void;
}

const OrderTrackerHeaderMobile: React.FC<OrderTrackerHeaderMobileProps> = ({
  orderId,
  onBack
}) => {
  // Truncate order ID if too long
  const getTruncatedOrderId = (id: string, maxLength: number = 15) => {
    if (id.length > maxLength) {
      return id.substring(0, maxLength) + '...';
    }
    return id;
  };

  return (
    <div className="order-tracker-header-mobile">
      <button className="back-button" onClick={onBack} aria-label="Go back">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path 
            d="M12.5 15L7.5 10L12.5 5" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </button>
      
      <div className="header-content">
        <div className="track-order-section">
          <h1 className="track-order-title">Track Order</h1>
          <div className="yellow-underline"></div>
        </div>
      </div>

      <div className="order-id-section">
        <span className="order-id-label">Order #</span>
        <span className="order-id-value">{getTruncatedOrderId(orderId)}</span>
      </div>
    </div>
  );
};

export default OrderTrackerHeaderMobile;